import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { LanguagesService } from '../../services/languages/languages.service';

export const languagesLoadedResolver: ResolveFn<void> = () => {
  const languagesService = inject(LanguagesService);

  if (languagesService.isLoaded) {
    return;
  }

  return firstValueFrom(languagesService.languagesLoadedSubject);
};
